import { ShieldCheck, ClipboardList, Users, Thermometer, FileText, AlertTriangle } from "lucide-react";

const services = [
  {
    icon: ShieldCheck,
    title: "HACCP Systems",
    desc: "Fully customised Hazard Analysis & Critical Control Point systems built for your exact kitchen and menu. EHO inspection-ready from day one.",
  },
  {
    icon: ClipboardList,
    title: "Allergen Management",
    desc: "Complete allergen matrices, staff guidance documents, and customer-facing information to keep you legally compliant and your customers safe.",
  },
  {
    icon: Users,
    title: "Staff Training",
    desc: "Practical, hands-on training sessions that give your team the knowledge and confidence to maintain food safety standards daily.",
  },
  {
    icon: Thermometer,
    title: "Temperature Monitoring",
    desc: "Pre-formatted daily temperature logs for fridges, freezers, hot holding and cooking probes. Out-of-range action columns and monthly summaries.",
  },
  {
    icon: FileText,
    title: "Compliance Records",
    desc: "Professional food safety management documents, manager declarations, and audit-ready records that meet UK food safety legislation.",
  },
  {
    icon: AlertTriangle,
    title: "Risk Identification",
    desc: "On-site audits to identify critical control points, potential hazards, and areas for improvement before your EHO inspection.",
  },
];

export default function Services() {
  return (
    <section
      data-testid="services-section"
      className="relative py-24 md:py-32 lg:py-40 bg-[#0d0d0d]/[0.93] grid-pattern"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
            Our Services
          </span>
          <h2
            data-testid="services-heading"
            className="font-heading text-3xl md:text-4xl font-medium text-white mt-4"
          >
            Professional Food Safety
            <br />
            <span className="text-zinc-500">Documentation & Compliance</span>
          </h2>
          <p className="mt-4 text-base text-zinc-500 max-w-xl mx-auto">
            Everything you need to pass your EHO inspection with confidence.
            Structured, precise, and operationally sound.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              data-testid={`service-card-${svc.title.toLowerCase().replace(/\s/g, '-')}`}
              className="gold-card p-8 group"
            >
              <div className="w-11 h-11 rounded-lg bg-[#c9a84c]/10 border border-[#c9a84c]/20 flex items-center justify-center mb-6 group-hover:bg-[#c9a84c]/20 transition-colors">
                <svc.icon size={20} className="text-gold" />
              </div>
              <h3 className="font-heading text-xl font-medium text-white mb-3">
                {svc.title}
              </h3>
              <p className="text-sm text-zinc-500 leading-relaxed">
                {svc.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom callout */}
        <div className="mt-16 text-center">
          <p className="text-sm text-zinc-500 italic">
            "If It's Not Recorded It <span className="text-gold font-medium not-italic">Didn't Happen.</span>"
          </p>
          <p className="text-xs text-zinc-600 mt-2">
            — <a href="https://www.legislation.gov.uk/ukpga/1990/16/contents" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Food Safety Act 1990</a> &middot; <a href="https://www.legislation.gov.uk/european/regulation/2004/0852" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">Regulation EC 852/2004</a>
          </p>
        </div>
      </div>
    </section>
  );
}
